import './style.scss';

import React from 'react';
import classnames from 'classnames';
import Checkmark from 'images/icons/controls/check.svg?react-svg';
import { localizeNumber } from 'shared/utils';
import { plainList } from 'scy/utils.mod.scss';
import { H5, SecondaryH5 } from 'scy/text';
import { highlight } from 'scy/text/styles.mod.scss';
import { flex, flex1 } from 'scy/flex.mod.scss';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';
import border from 'scy/border.mod.scss';

export default function LoyaltyIncentiveList({ completed, uncompleted }) {
  return (
    <section className={classnames(border.topMedium, margin.bottom_md)}>
      <ul className={plainList}>
        {uncompleted.map(incentive => (
          <ListItem
            key={incentive.title}
            title={incentive.title}
            points={incentive.points}
            completed={incentive.completed}
          />
        ))}
      </ul>
      <ul className={plainList}>
        {completed.map(incentive => (
          <ListItem
            key={incentive.title}
            title={incentive.title}
            points={incentive.points}
            completed={incentive.completed}
          />
        ))}
      </ul>
    </section>
  );
}

function ListItem({ title, points, completed }) {
  const pointValue = localizeNumber(points);
  const Name = completed ? SecondaryH5 : H5;
  const Value = completed ? SecondaryH5 : H5;

  return (
    <li className={classnames(flex, padding.sm, border.bottomMedium)}>
      <Name tag="div" uppercase className={flex1} marginClass={margin.xs}>
        {title}
        {!!completed && (
          <span className={margin.left_xs}>
            <Checkmark
              width={16}
              height={16}
              style={{ verticalAlign: 'text-bottom' }}
            />
          </span>
        )}
      </Name>
      <Value
        tag="div"
        marginClass={margin.xs}
        className={completed ? null : highlight}
      >
        +{pointValue}
      </Value>
    </li>
  );
}
